import { useState } from 'react';
import moment from 'moment';

export type TimeRange = 'daily' | 'weekly' | 'monthly' | 'custom';

export interface DateRange {
  startTime: Date;
  endTime: Date;
}

export const computeDateRange = (
  timeRange: TimeRange,
  customDateRange: [moment.Moment, moment.Moment] | null,
): DateRange | null => {
  const now = moment();

  if (timeRange === 'custom') {
    if (!customDateRange) return null;
    return {
      startTime: customDateRange[0].toDate(),
      endTime: customDateRange[1].toDate(),
    };
  }

  if (timeRange === 'daily') {
    return {
      startTime: now.clone().startOf('day').toDate(),
      endTime: now.toDate(),
    };
  }

  if (timeRange === 'weekly') {
    return {
      startTime: now.clone().subtract(7, 'days').startOf('day').toDate(),
      endTime: now.clone().endOf('day').toDate(),
    };
  }

  if (timeRange === 'monthly') {
    return {
      startTime: now.clone().subtract(30, 'days').startOf('day').toDate(),
      endTime: now.clone().endOf('day').toDate(),
    };
  }

  return {
    startTime: now.clone().startOf('day').toDate(),
    endTime: now.toDate(),
  };
};

export const useTimeRange = () => {
  const [timeRange, setTimeRange] = useState<TimeRange>('weekly');
  const [customDateRange, setCustomDateRange] = useState<[moment.Moment, moment.Moment] | null>(null);

  const isReadyToFetch = timeRange !== 'custom' || customDateRange !== null;

  return { timeRange, setTimeRange, customDateRange, setCustomDateRange, isReadyToFetch };
};
